
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box,Stack, Select ,MenuItem,Typography,Grid,Divider,Button} from "@mui/material";
import { useDispatch, useSelector } from "react-redux"
import { useState,useEffect } from 'react'; 

import { updateSelectedCapacity } from "../Redux/products";
import CustomAxios from '../utils/CustomAxios';
import { updateUserCart } from '../Redux/user';

const styles = {
    heading: { fontSize: { xs: "24", sm: "24px", md: "32px" }, fontWeight: "700", lineHeight: "48px", color: "black" },
    subHeading: { fontSize: { xs: "16", sm: "16px", md: "20px" }, fontWeight: "400", lineHeight: "30px", color: "black" },
    productHeading: { fontSize: { md: "16px" }, fontWeight: "600", lineHeight: "24px", color: "black" },
    productContent: { fontSize: { md: "12px" }, fontWeight: "400", lineHeight: "18px", color: "black" },
    productSize: { fontSize: { md: "10px" }, fontWeight: "400", lineHeight: "15px", color: "grey.600" },
    itemHeading: { fontSize: { xs: "12px", md: "14px" }, fontWeight: "400", lineHeight: "18px", color: "black" },

}
const ProductCard = ({ item, productsType })=>{
    const selectedHub = useSelector(state => state.user.selected_hub); 
    const dispatch=useDispatch()    
    const [imageError, serImageError] = useState(true)
    let selected_capacities=useState() 
    const selectedCapacityid=useSelector(state=>state.products.selectedCapacity)
    const selectedCapacity=selectedCapacityid[item.id]||item.capacitydetails[selectedHub]?.capacities[0]
    const user=useSelector(state=>state.user.id)
    let userCart=useSelector(state=>state.user.userCart)


    // const selectedCapacity = selectedCapacityid[1];
    // console.log(selectedCapacity)
    // console.log(products)
    const is320px = "";
    const is1650px = "";
    const is2560px = "";
    const cartCheck=(id)=>{
        const filt=userCart.filter(item=>item.product_id==id)[0]
        // console.log(filt)
        if (filt){
            let cap=filt.capacity.filter(item=>item.item_capacity==selectedCapacity.item_capacity)[0]
            // console.log(cap)
            return cap.item_quantity ?cap.item_quantity:0
        }
        else {
            return 0
        }
        
            }
            const updateQuantity=(updateItem,inc,e)=>{
                // console.log(updateItem)
               
                    let updateCart=[...userCart]
                    const filt=userCart.map(item=>{
                        if (item.product_id==updateItem.id){
                            let updatingItem={...item}
                           let newcap =updatingItem.capacity.map(cap=>{
                                if (cap.item_capacity ==selectedCapacity.item_capacity){

                                    let updateqty={...cap}
                                        if (inc){
                                            updateqty.item_quantity+=1
                                        }
                                        else{
                                            updateqty.item_quantity-=1
                                        }
                                        return updateqty
                                }
                                else{
                                    return cap
                                }
                            })
                            updatingItem.capacity=newcap
                            if (inc){
                                updatingItem.quantity+=1
                            }
                            else{
                                updatingItem.quantity-=1
                            }
                            
                            return updatingItem
                        }
                        else{
                            return item
                        }
                    })    
                    // console.log(filt)
                    dispatch(updateUserCart(filt))
               
        
            }
            const addCart=(newitem,quantity,e)=>{
                try {
                    // Prevent event bubbling
                    if (e) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                    
                    let capacity={...newitem.capacitydetails}
                    const hubId = Array.isArray(selectedHub) ? selectedHub[0] : selectedHub;
                    const existingProduct = userCart.find(item=>item.product_id==newitem.id);
                    
                    if(!existingProduct){
                        // Product not in cart - add new
                        if (!capacity[hubId] || !capacity[hubId].capacities) {
                            console.warn('No capacity details found for hub:', hubId);
                            return;
                        }
                        
                        let updatedCapacity=[]
                        capacity[hubId].capacities.forEach(item=>{
                            if (item.item_capacity==selectedCapacity.item_capacity){
                                let update={...item}
                                update.item_quantity=1
                                updatedCapacity.push(update)
                            } else {
                                updatedCapacity.push(item)
                            }
                        }) 
                        let payload={
                            capacity:updatedCapacity,
                            quantity:1,
                            product_id:newitem.id,
                            order_origin: productsType // persist origin (walkin/online)
                        }
                        dispatch(updateUserCart([...userCart,payload]))
                    } else {
                        // Product exists in cart - update quantity
                        let returned=userCart.map(filt=>{
                            let newobj={...filt}
                            if (newobj.product_id==newitem.id){
                                let newcap=[]
                                let foundCap = false;
                                
                                newobj.capacity.forEach(cap=>{
                                    if(cap.item_capacity==selectedCapacity.item_capacity){
                                        let updateCap={...cap}
                                        updateCap.item_quantity = (updateCap.item_quantity || 0) + 1
                                        newcap.push(updateCap)
                                        foundCap = true;
                                    } else {
                                        newcap.push(cap)
                                    }
                                })
                                
                                // If capacity doesn't exist, add it
                                if (!foundCap && capacity[hubId] && capacity[hubId].capacities) {
                                    const newCap = capacity[hubId].capacities.find(c => c.item_capacity == selectedCapacity.item_capacity);
                                    if (newCap) {
                                        newcap.push({...newCap, item_quantity: 1});
                                    }
                                }
                                
                                newobj.capacity=newcap
                                newobj.quantity = newcap.reduce((sum, c) => sum + (c.item_quantity || 0), 0);
                                // ensure origin persists
                                if (!newobj.order_origin) {
                                    newobj.order_origin = productsType;
                                }
                            }
                            return newobj
                        })
                        dispatch(updateUserCart(returned))
                    }
                } catch (error) {
                    console.error('Error adding to cart:', error);
                }
            }
            // useEffect(()=>{
            //     console.log(userCart)
            // },[userCart])
        const selectCapacity=(cap,item)=>{
        // console.log(selectedCapacityid)
        // let alreadyupdated=[...selec]
        // const  capacitySelection={}
        
        dispatch(updateSelectedCapacity({[item.id]:cap}))
        
        }
        // console.log(item)
        const capacityavailable=()=>{
            // console.log(item,selectedCapacity)
            // const value=item.capacitydetails[selectedHub[0]].capacities.map(item=>{
                
            //     // if (item.id==selectedCapacity.id){
            //         console.log(item.id,item.item_available)
            //         return{ [selectedCapacity.id]:item.item_available}


            //     // }
            // })
            // console.log(value.filter(item=>item[selectedCapacity.id])[0][selectedCapacity.id])
                return selectedCapacity.item_available
        }
    const handleProductClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        
        // Check availability
        const isAvailable = capacityavailable();
        const hasUnits = productsType == 'online' 
            ? (item.inventryDetails?.available_units > 0) 
            : (item?.available_units > 0);
        
        if (!isAvailable) {
            console.warn('Product capacity not available');
            return;
        }
        
        if (!hasUnits) {
            console.warn('Product out of stock');
            return;
        }
        
        if (!selectedCapacity) {
            console.warn('No capacity selected');
            return;
        }
        
        // Add to cart
        addCart(item, 1, e);
    };
    
    return item.capacitydetails[selectedHub[0]] &&<Grid item xs={8} sm={8} md={8} lg={3} key={item.id} sx={{ alignSelf: "flex-start",display:"flex",flexDirection:"column",p:{xs:"8px 4px",sm:"12px 16px",lg:"12px 16px"}}} >
    <Box 
        onClick={handleProductClick}
        sx={{ 
            width:"100%", 
            aspectRatio: { xs: "1 / 1", md: "1 / 1" }, 
            maxHeight: { xs: "100px", md: "none" },
            background:"#FFFFFF",
            borderRadius:"8px",
            boxShadow:"3px 2px 4px #0005",
            overflow:"hidden",
            cursor: "pointer",
            position: "relative",
            "&:hover": {
                boxShadow: "3px 2px 8px #0008"
            }
        }} 
    >
        {item.bogo_offer && (
            <Box sx={{
                position: "absolute",
                top: { xs: "4px", md: "8px" },
                left: { xs: "4px", md: "8px" },
                background: "#52C41A",
                borderRadius: { xs: "4px", md: "6px" },
                padding: { xs: "2px 6px", md: "4px 8px" },
                zIndex: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
            }}>
                <Typography sx={{ 
                    fontSize: { xs: "8px", md: "10px" }, 
                    fontWeight: "700", 
                    color: "#FFFFFF",
                    lineHeight: 1.2,
                    textAlign: "center"
                }}>
                    Buy 1
                </Typography>
                <Typography sx={{ 
                    fontSize: { xs: "8px", md: "10px" }, 
                    fontWeight: "700", 
                    color: "#FFFFFF",
                    lineHeight: 1.2,
                    textAlign: "center"
                }}>
                    Get 1
                </Typography>
            </Box>
        )}
        {item.images && productsType == 'online'&&<Box component="img" sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} src={imageError ? item?.images[0] : "img"} />}
        {item.image_urls && productsType == 'walkin' &&<Box component="img" sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} src={imageError ? item.image_urls[0] : "img"} />}
    </Box>
    <Typography 
        sx={{ 
            ...styles.itemHeading, 
            mt: { xs: "6px", md: "12px" }, 
            textAlign: "center", 
            fontSize: { xs: "10px", md: "14px" }, 
            lineHeight: { xs: "14px", md: "18px" },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
        }}
    >
        {item.item_name}
    </Typography>
</Grid>
}
export default ProductCard